export default {
  setNewReservations: (state, newReservations) => {
    state.newReservations = newReservations;
  }
};
